<!--
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2021-07-05 14:55:23
 * @LastEditors: Yang Zhang
 * @LastEditTime: 2022-05-13 11:32:07
-->
<template>
  <svg :class="svgClass" v-bind="$attrs" :style="{ color: color }">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script setup>
import { defineProps, computed } from 'vue'

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: ''
  },
  btnname: {
    type: String,
    default: ''
  }
})

const iconName = computed(() => `#${props.name}`)
const svgClass = computed(() => {
  if (props.name) {
    return `svg-icon ${props.name}`
  }
  return 'svg-icon'
})
</script>

<style lang="less">
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: middle;
  fill: currentColor;
  overflow: hidden;
}
</style>
